import DataGrid, { Paging, Column } from 'devextreme-react/data-grid';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'react-bootstrap';
import React, { useState, useEffect, useRef } from 'react';
import ChatService from '../../services/chatservice';
import LiveChat from '../chat/livechat';
import ChannelIcon from '../chat/channelIcon';
import Toastr from '../utils/toastr';
import TransferModal from './transfermodal';

function ActiveChats(props) {
    const { t } = useTranslation();
    const [activeChats, setActiveChats] = useState([]);
    const [showLiveChat, setshowLiveChat] = useState(false);
    const [chat, setChat] = useState(null);
    const toastrRef = useRef(null);
    const [showTransferModal, setShowTransferModal] = useState(false);

    useEffect(() => {
        setActiveChats(props.activeChats);
        return () => {
            // component unmounts
        };
    }, [props.activeChats]);

    const chatClick = (guid) => {
        ChatService.getChat(guid, res => {
            if (res?.data?.guid) {
                setChat(res.data);
                toggleLiveChat();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
        });
    }

    const viewChatCell = (dataCell) => {
        let ret = <></>;
        if (dataCell.value)
            ret = <Button key={dataCell.value} variant="light-primary" size='sm'
                onClick={e => {
                    chatClick(dataCell.value)
                }}><FontAwesomeIcon icon={duotone('eye')} />
            </Button>
        return ret;
    }
    const toggleLiveChat = () => {
        setshowLiveChat(!showLiveChat);
    }

    const toggleChatTransfer = () => {
        setShowTransferModal(!showTransferModal);
    }

    const chatTransfer = (chat) => {
        ChatService.getChat(chat.data.guid, res => {
            if (res?.data?.guid) {
                setChat(res.data);
                toggleChatTransfer();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
        });
    }

    const transferChatCell = (dataCell) => {

        return <Button variant='light-primary' size='sm'
            onClick={e => {
                chatTransfer(dataCell)
            }
            }>
            <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
        </Button>
    }

    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-network")} /> {t("socialnetwors")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <DataGrid
                    id='agentactivechats'
                    dataSource={activeChats}
                    rowAlternationEnabled={true}
                    keyExpr="guid"
                    showBorders={true}
                    noDataText=""
                >
                    <Column cssClass={"align-middle"} dataField="transfer" caption={""} showInColumnChooser={false} width={60} cellRender={transferChatCell} />
                    <Column dataField="channel" caption={t("channel")} width={"10%"} cellRender={chn => <ChannelIcon channel={chn.value} />} alignment="center" />
                    <Column dataField="assignmentDate" caption={t("time")} dataType="datetime" format='HH:mm:ss' selectedFilterOperation=">=" width={"25%"} />
                    <Column dataField="from" caption={t("from")} width={"25%"} />
                    <Column dataField="groupName" caption={t("group")} width={"20%"} />
                    <Column dataField="guid" caption={""} width={"20%"} cellRender={viewChatCell} alignment="center" />
                    <Paging
                        showPageSizeSelector={true}
                        allowedPageSizes={[3, 5, 9, 12, 15]}
                        showInfo={true} />
                    <Paging defaultPageSize={3} />
                </DataGrid>
            </div>
            {
                chat !== null &&
                <LiveChat show={showLiveChat} toggleModal={toggleLiveChat} chat={chat} agent={props.agent}></LiveChat>
            }
            <TransferModal show={showTransferModal} toggleModal={toggleChatTransfer} chat={chat}></TransferModal>
            <Toastr ref={toastrRef} />
        </div>
    )
}

export default ActiveChats;